import { FC } from 'react';
import {useRef, useState} from "react";
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import AdminUsers from '../../../pages/accessRights/users/adminUsers';
import SectionContent from '../../../components/sectionContent/sectionContent';
import Sidebar from '../../../components/sidebar/Sidebar';
import HeaderBtn from '../../../components/headerBtn/headerBtn';

import '../../../scss/App.scss';

const AdminUrersSection: FC = () => {

	const { claims } = useSelector((state: any) => state.user.user.data);

	const [overflowedBtnsCount] = useState<number>(0);
	const [isOpenGroupBtn] = useState<boolean>(false);

	const buttonsContainerRef = useRef<HTMLDivElement>(null);

	const availableButtons = [
		(claims.includes('admin') || claims.includes('claim:employee:add')) && {
			component: (
				<HeaderBtn
					content='Добавить'
					purpose='newUsersClaims'
					modalTitle='Добавить пользователя'
				/>
			)
		},
		(claims.includes('admin') || claims.includes('claim:employee:delete')) && {component: (
				<HeaderBtn
					content='Удалить'
					purpose='deleteUsersClaims'
					modalTitle='Удаление персональных прав доступа у сотрудника'
				/>
			)
		},
	];
	const filteredAvailableButtons = availableButtons.filter((btn: JSX.Element) => btn);

	const displayedAvailableBtns = filteredAvailableButtons
	?.slice(-(overflowedBtnsCount as number))
	?.map((elem: {component: JSX.Element}, index: number) => {
		return elem && <div key={index}>{elem?.component}</div>;
	});

	const displayedHeadBtns = filteredAvailableButtons
		?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
		?.map((elem: {component: JSX.Element}, index: number) => {
			return elem && <div key={index}>{elem?.component}</div>;
		});

	return (
		<div className='App'>
			<Sidebar />
			<SectionContent
				availableButtons={displayedAvailableBtns}
				buttonsContainerRef={buttonsContainerRef}
				headBlockChildren={displayedHeadBtns}
				isOpenGroupBtn={isOpenGroupBtn}
				section='Права доступа'
				pageName='accessRights'
				title='Пользователи'
			>
				<div className='content__main'>
					<div className='btns'>
						{(claims.includes('admin') ||
							claims.includes('role:claim:change')) && (
							<Link to='/accessRights/roles' className='tab'>
								<div className='buttons__btn'>Роли</div>
							</Link>
						)}
						{(claims.includes('admin') ||
							claims.includes('customers:list')) && (
							<Link to='/accessRights/customers' className='tab'>
								<div className='buttons__btn'>
									Клиенты
								</div>
							</Link>
						)}
						{(claims.includes('admin') ||
							(claims.includes('role:claim:change') && claims.includes('claim:employee:list'))) && (
								<Link to='/accessRights/users' className='tab'>
							<div className='buttons__btn --active'>Пользователи</div>
						</Link>
						)}
					</div>
					<AdminUsers />
				</div>
			</SectionContent>
		</div>
	);
};

export default AdminUrersSection;
